import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PersonalInfo from 'components/PersonalInfo';
import ParentInfo from 'components/ParentInfo';
import SportsBoard from 'components/SportsBoard';
import Stepper from 'react-stepper-horizontal';
import AcademicBoard from 'components/AcademicBoard';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component

import { saveSAProfile, getSAProfile, searchSchools } from './actions';
import { selector } from './redux';
import styles from './GetUserDetails.scss';// to import local scss fle


class GetUserDetails extends Component {


  static propTypes = {
    saved: PropTypes.bool,
    history: PropTypes.shape(),
    saveSAProfile: PropTypes.func,
    getSAProfile: PropTypes.func,
    attributes: PropTypes.shape(),
    editRequested: PropTypes.bool,
    profile: PropTypes.shape(),
    usedFor: PropTypes.string,
  };
  static defaultProps = {
    saved: false,
    history: { push: () => {} },
    saveSAProfile: () => {},
    getSAProfile: () => {},
    attributes: {},
    profile: {},
    editRequested: false,
    usedFor: '',
  };

  static deriveState(value) {
    const state = { basicInfo: false,
      sportsBoard: false,
      academicBoard: false,
      parentFirstStep: false,
      parentSecondStep: false,
      parentThirdStep: false,
      parentLastStep: false,
    };
    if (value === 'personalInfo') {
      state.basicInfo = true;
    } else if (value === 'sportsBoard') {
      state.sportsBoard = true;
    } else if (value === 'academicBoard') {
      state.academicBoard = true;
    } else if (value === 'parentFirstStep') {
      state.parentFirstStep = true;
    } else if (value === 'parentSecondStep') {
      state.parentSecondStep = true;
    } else if (value === 'parentThirdStep') {
      state.parentThirdStep = true;
    } else {
      state.parentLastStep = true;
    }
    return state;
  }


  constructor(props) {
    super(props);
    this.state = {
      basicInfo: true,
      sportsBoard: false,
      academicBoard: false,
      showCrossButton: false,
      parentFirstStep: true,
      parentSecondStep: false,
      parentThirdStep: false,
      parentLastStep: false,
      steps: [{
        onClick: (e) => {
          this.setState({
            basicInfo: true,
            sportsBoard: false,
            academicBoard: false,
            currentStep: 0,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            basicInfo: false,
            sportsBoard: true,
            academicBoard: false,
            currentStep: 1,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            basicInfo: false,
            sportsBoard: false,
            academicBoard: true,
            currentStep: 2,
          });
          e.preventDefault();
        } }],
      parentSteps: [{
        onClick: (e) => {
          this.setState({
            parentFirstStep: true,
            parentSecondStep: false,
            parentThirdStep: false,
            parentLastStep: false,
            currentStep: 0,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            parentFirstStep: false,
            parentSecondStep: true,
            parentThirdStep: false,
            parentLastStep: false,
            currentStep: 1,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            parentFirstStep: false,
            parentSecondStep: false,
            parentThirdStep: true,
            parentLastStep: false,
            currentStep: 2,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            parentFirstStep: false,
            parentSecondStep: false,
            parentThirdStep: false,
            parentLastStep: true,
            currentStep: 3,
          });
          e.preventDefault();
        } },
      ],
      currentStep: 0,
      profile: 'PENDING',
    };
    this.next = this.next.bind(this);
    this.save = this.save.bind(this);
    this.tooglePreference = this.tooglePreference.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved && this.props.saved !== nextProps.saved) {
      this.props.history.push('/view/athlete');
    } else if (this.props.attributes !== nextProps.attributes) {
      const profile = nextProps.attributes.get('profile');

      if (profile !== 'PENDING') {
        this.setState({ profile });
        this.setState({ showCrossButton: true });
        this.props.getSAProfile(profile);
      }
    }
  }

  tooglePreference(value) {
    this.setState({ currentStep: this.state.currentStep - 1 });
    this.setState({ ...GetUserDetails.deriveState(value) });
    window.scrollTo(0, 0);
  }


  next(to, state) {
    window.scrollTo(0, 0);
    this.setState({ currentStep: this.state.currentStep + 1 });
    this.setState({ ...GetUserDetails.deriveState(to), ...state });
  }


  save(newState) {
    this.setState({ ...newState }, () => {
      const s = this.state;
      let payload = this.props.profile.toJS();
      const { city, state, school, height, weight, year_of_graduation, gpa, sat,
          act, sportName, t40, bench, squats, firstName, lastName,
          primary_offensive_position_pref, primary_defensive_position_pref,
          instagram, twitter, secondary_offensive_position_pref, mobile,
          secondary_defensive_position_pref, special_teams, hbcu } = s;
      const academic = { year_of_graduation, gpa, hbcu };
      if (sat !== '') {
        academic['sat'] = sat; //eslint-disable-line
      }
      if (act !== '') {
            academic['act'] = act; //eslint-disable-line
      }

      let sports = {};
      if (this.state.profile === 'PENDING') {
        sports = { sportName,
          t40,
          bench,
          squats };
        if (primary_offensive_position_pref !== '') { //eslint-disable-line
            sports['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
        }
        if (primary_defensive_position_pref !== '') { //eslint-disable-line
            sports['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
        }
        if(secondary_defensive_position_pref !== ''){ //eslint-disable-line
            sports['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
        }
          if(secondary_offensive_position_pref !== ''){ //eslint-disable-line
              sports['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
          }
          if(special_teams !== ''){ //eslint-disable-line
              sports['special_teams'] = special_teams; //eslint-disable-line
          }
      } else {
        sports[sportName] = { t40, bench, squats };
          if (primary_offensive_position_pref !== '') { //eslint-disable-line
              sports[sportName] = primary_offensive_position_pref; //eslint-disable-line
          }
          if (primary_defensive_position_pref !== '') { //eslint-disable-line
              sports[sportName] = primary_defensive_position_pref; //eslint-disable-line
          }
          if(secondary_defensive_position_pref !== ''){ //eslint-disable-line
              sports[sportName] = secondary_defensive_position_pref; //eslint-disable-line
          }
          if(secondary_offensive_position_pref !== ''){ //eslint-disable-line
              sports[sportName] = secondary_offensive_position_pref; //eslint-disable-line
          }
          if(special_teams !== ''){ //eslint-disable-line
              sports[sportName] = special_teams; //eslint-disable-line
          }
      }
      const fullname = `${firstName} ${lastName}`;
      payload = Object.assign(payload, {
        city,
        sa_state: state,
        school,
        height,
        weight,
        academic,
        sports,
        sa_mobile: mobile,
        fullname,
      });
      if (instagram) {
        let instagramUrl = '';
        if (instagram.startsWith('https')) {
          instagramUrl = instagram;
        } else {
          instagramUrl = `https://instagram.com/${instagram}`;
        }
        payload['sa_instagram'] = instagramUrl; //eslint-disable-line
      }
      if (twitter) {
        let twitterUrl = '';
        if (twitter.startsWith('https')) {
          twitterUrl = twitter;
        } else {
          twitterUrl = `https://twitter.com/${twitter}`;
        }

        payload['sa_twitter'] = twitterUrl; //eslint-disable-line
      }
      this.props.saveSAProfile(payload, this.state.profile);
    });
  }


  render() {
    const renderLoader = renderIf(this.props.editRequested);
    const renderItForAthlete = renderIf(this.props.usedFor === 'athlete');
    const renderItForParent = renderIf(this.props.usedFor === 'parent');
    return (
      <div className={cn('row', styles.getUserDetailsContainer)} >
        {renderLoader(<FullScreenLoader />)}
        {renderItForAthlete(
          <div className={cn('col s12')}>
            <div className={cn('col s12', styles.tabsContainer)}>
              <div className={cn('col s12', styles.tabsHeader)}>
                <span>Step {this.state.currentStep + 1} of 3</span>
              </div>
              <div className={cn('col s12', styles.tabsButtonsContainer)}>
                <div className={styles.maxWidth}>
                  <span>
                    <Stepper
                      steps={this.state.steps}
                      activeColor={'#FFF'}
                      circleFontColor={'#FFF'}
                      defaultTitleColor={'#EBEBEB'}
                      activeTitleColor={'#FFF'}
                      completeBarColor={'#FFF'}
                      activeStep={this.state.currentStep}
                    />
                    <span className={cn('col s12', styles.texts)}>
                      <div className={cn('col s4', styles.textBelow)}>
                    Personal Info
                  </div>
                      <div className={cn('col s4', styles.textBelow)}>
                    Sports Board
                  </div>
                      <div className={cn('col s4', styles.textBelow)}>
                    Academic Board
                  </div>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className={cn('col s12', styles.getInfoBox)}>
              <PersonalInfo {...this.props} next={state => this.next('sportsBoard', state)} show={this.state.basicInfo} />
              <SportsBoard {...this.props} next={state => this.next('academicBoard', state)} back={() => this.tooglePreference('personalInfo')} show={this.state.sportsBoard} />
              <AcademicBoard {...this.props} back={() => this.tooglePreference('sportsBoard')} save={state => this.save(state)} show={this.state.academicBoard} />
            </div>
          </div>,
          )}
        {renderItForParent(
          <div className={cn('col s12')}>
            <div className={cn('col s12', styles.tabsContainer)}>
              <div className={cn('col s12', styles.tabsHeader)}>
                <span>Step {this.state.currentStep + 1} of 3</span>
              </div>
              <div className={cn('col s12', styles.tabsButtonsContainer)}>
                <div className={styles.maxWidth}>
                  <span>
                    <Stepper
                      steps={this.state.parentSteps}
                      activeColor={'#FFF'}
                      circleFontColor={'#FFF'}
                      defaultTitleColor={'#EBEBEB'}
                      activeTitleColor={'#FFF'}
                      activeStep={this.state.currentStep}
                    />
                    <span className={cn('col s12', styles.texts)}>
                      <div className={cn('col s3', styles.textBelow)}>
                        PersonalInfo
                        </div>
                      <div className={cn('col s3', styles.textBelow)}>
                        StudentInfo
                        </div>
                      <div className={cn('col s3', styles.textBelow)}>
                         Sports Board
                      </div>
                      <div className={cn('col s3', styles.textBelow)}>
                        Academic Board
                      </div>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className={cn('col s12', styles.getInfoBox)}>
              <ParentInfo {...this.props} next={state => this.next('parentSecondStep', state)} show={this.state.parentFirstStep} />
              <PersonalInfo {...this.props} next={state => this.next('parentThirdStep', state)} show={this.state.parentSecondStep} />
              <SportsBoard {...this.props} next={state => this.next('', state)} back={() => this.tooglePreference('personalInfo')} show={this.state.parentThirdStep} />
              <AcademicBoard {...this.props} back={() => this.tooglePreference('sportsBoard')} save={state => this.save(state)} show={this.state.parentLastStep} />
            </div>
          </div>,
          )}
      </div>
    );
  }
}

export default connect(selector, { saveSAProfile, getSAProfile, searchSchools })(GetUserDetails);



// WEBPACK FOOTER //
// ./src/components/GetUserDetails/GetUserDetails.js